export default __webpack_public_path__ + "static/media/1cbbaa6e02e704bbf4032c5880bf382b.2dd9e92e.jpg";